import { z } from 'zod'

import { Appraiser } from 'src/shared/components/icons/professions/appraiser'
import { Attorney } from 'src/shared/components/icons/professions/attorney'
import { Contractor } from 'src/shared/components/icons/professions/contractor'
import { Inspector } from 'src/shared/components/icons/professions/inspector'
import { InsuranceBroker } from 'src/shared/components/icons/professions/insurance-broker'
import { LoanOfficer } from 'src/shared/components/icons/professions/loan-officer'
import { RealEstateAgent } from 'src/shared/components/icons/professions/real-estate-agent'
import { TitleRep } from 'src/shared/components/icons/professions/title-rep'
import type { MapItem } from 'src/shared/schemas/utils'

export type Profession =
  | 'real_estate_agent'
  | 'mortgage_loan_officer'
  | 'real_estate_insurance_broker'
  | 'contractor'
  | 'real_estate_attorney'
  | 'property_inspector'
  | 'real_estate_appraiser'
  | 'title_company_rep'

export enum ProfessionEnum {
  REAL_ESTATE_AGENT = 'real_estate_agent',
  MORTGAGE_LOAN_OFFICER = 'mortgage_loan_officer',
  REAL_ESTATE_INSURANCE_BROKER = 'real_estate_insurance_broker',
  CONTRACTOR = 'contractor',
  REAL_ESTATE_ATTORNEY = 'real_estate_attorney',
  PROPERTY_INSPECTOR = 'property_inspector',
  REAL_ESTATE_APPRAISER = 'real_estate_appraiser',
  TITLE_COMPANY_REP = 'title_company_rep',
}

export const ALL_PROFESSIONS: Profession[] = [
  'real_estate_agent',
  'mortgage_loan_officer',
  'real_estate_insurance_broker',
  'contractor',
  'real_estate_attorney',
  'property_inspector',
  'real_estate_appraiser',
  'title_company_rep',
]

export const professionMap: Record<Profession, MapItem & { labelShort: string }> = {
  real_estate_agent: {
    label: 'Real estate agent',
    labelShort: 'Agent',
    lowerCaseLabel: 'real estate agent',
    subtitle: 'Buy, sell or lease',
    icon: RealEstateAgent,
  },
  mortgage_loan_officer: {
    label: 'Mortgage loan officer',
    labelShort: 'Loan officer',
    lowerCaseLabel: 'mortgage loan officer',
    subtitle: 'Purchase or refinance',
    icon: LoanOfficer,
  },
  real_estate_insurance_broker: {
    label: 'Insurance broker',
    labelShort: 'Insurance broker',
    lowerCaseLabel: 'insurance broker',
    icon: InsuranceBroker,
  },
  contractor: {
    label: 'Contractor',
    labelShort: 'Contractor',
    lowerCaseLabel: 'contractor',
    icon: Contractor,
  },
  real_estate_attorney: {
    label: 'RE attorney',
    labelShort: 'Attorney',
    lowerCaseLabel: 'RE attorney',
    icon: Attorney,
  },
  property_inspector: {
    label: 'Property inspector',
    labelShort: 'Inspector',
    lowerCaseLabel: 'property inspector',
    icon: Inspector,
  },
  real_estate_appraiser: {
    label: 'RE appraiser',
    labelShort: 'Appraiser',
    lowerCaseLabel: 'RE appraiser',
    icon: Appraiser,
  },
  title_company_rep: {
    label: 'Title company rep',
    labelShort: 'Title rep',
    lowerCaseLabel: 'title company rep',
    icon: TitleRep,
  },
}

export const professionSchema = z.enum(Object.keys(professionMap) as [Profession, ...Profession[]])
